import { trim } from '../../../../../components/textfield/validator.min'

const reportDB = require('../../../../../components/report/report-db')
const report = require('../../../../../components/report/report')
const style = require('../../../../../components/report/report-style')
const css = style.get()




export function start(detail) {   //console.log('style 55555555555555555555>', css)

  const phpFile = 'server/php/sql/report.php'
  let dataDbid = '';

  dataDbid = detail.dbid
  detail.inf = { entity: 'inventory', report: 'inventory-report-one', id: dataDbid, item_unit_id: detail.item_unit_id }

  reportDB.select(detail, phpFile, (data) => { //console.log('reportTest 5>', data)
    //console.log('reportTest 5>', data)
    insert(detail, data)

  })



}/**/


function insert(detail, data) { //console.log('REPORT maixxxx>', style.start('f32'))

  report.show(detail, () => {


    const pageTarget = document.getElementById('report-page-right')
    const body = generate(detail, data[0])

    pageTarget.insertAdjacentHTML("beforeend", body)

  })

}/*insert*/





function generate(detail, data) {

  var body = ''

  const purchaseItem = data != undefined ? JSON.parse(data.purchaseItem) :  [];
  const soldItem =  data != undefined ? JSON.parse(data.soldItem):  [];


  body += generateHeader(detail, data)
  body += generateTop(data)
  body += generatePurchaseTable(purchaseItem)
  body += generateSoldTable(soldItem)



  body += `</div> <!-- dataCont -->`
  body += `<div class="report-page">`

  return body
}

function generateHeader(detail, data) {

  var header = ''
  header += `<div class="report-page" id="miDiv5" ${css.table}>`
  header += `
                    <div class="report-appbar report-appbar-black" >

                            <div  data-detail='{"click": [ 
                                                        {"dest":"ripple" }, 
                                                        {"dest":"report", "act":"remove" } ] }' >
                                <svg><use xlink:href="../css/svg.svg#close"></use></svg>
                            </div>

                            <h1>Item Inventory Report</h1>

                        <div class="fr" data-detail='{"click": [ 
                                                    {"dest":"ripple" }, 
                                                    {"dest":"report", "act":"print" }  ] }' >
                                <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                <label>Print</label>
                        </div>
                    </div> <!-- appbar -->
            `

  header += `
                    <div class="dataCont">
                        <h1  ${css.f32}>${trim(detail.item_name) + ' - ' + trim(detail.item_unit_name)}</h1>
                        <p   ${css.f14} >Offers a comprehensive summary by unit, showing average cost and sales price, stock valuation,
                                          and detailed insights into available purchases and associated sales activity.</p>
            `
  return header


}

function generateTop(data) { //console.log('generateTop>>>', data)

  var table = ` <table ${css.table} > `
  table += `
                <tr>
                 
                  <th ${css.thNoline}    >Total Available</th>
                  <th ${css.thNoline}    >AVG Purchase Price</th>
                  <th ${css.thNoline}    >AVG Sold Price</th>
                  <th ${css.thNoline}    >In Stock Value</th>
    
                </tr> 

                <tr>
                  
                  <td ${css.td0}  ><b>${data != undefined ? data.available_total : ''}   </b></td>
                  <td ${css.td0}  ><b>${data != undefined ? data.avg_purchase_price : ''}   </b></td>
                  <td ${css.td0}  ><b>${data != undefined ? data.avg_selling_price : ''} </b></td>
                  <td ${css.td0}  ><b>${data != undefined ? data.in_stock_value : ''} </b></td>
                </tr> 
            `

  table += `</table>`

  return table

}/**/


function generatePurchaseTable(purchaseItem) {

  var purchaseTotal = 0;
  var table = `
              <h2 ${css.tableTitle}>Purchase Item</h2>                        
              <table ${css.table} >
                <tr>
                  <th ${css.th}>PO#</th>
                  <th ${css.th}>PO DATE</th>
                  <th ${css.th}>PROVIDER</th>
                  <th ${css.th}>ORIGINAL QTY</th>
                  <th ${css.th}>AVAILABLE QTY</th>
                  <th ${css.th}>UNIT PRICE</th>
                  <th ${css.th}>ROW TOTAL</th>
                </tr> 
        `
  if (purchaseItem !== null) {
    for (let i = 0; i < purchaseItem.length; i++) { //console.log('for>>>', soldItem.length)

      let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
                          {"dest":"report",  "act":"jump", 
                           "actJump":"goToPurchase", "dtId":"purchase-dt", "toSearch":"${purchaseItem[i].purchase_code}"  } ] }'`

      table += `
                <tr>
                  <td class='tdClick' ${css.td} ${detailHtml} >${purchaseItem[i].purchase_code}</td>
                  <td ${css.td}>${purchaseItem[i].pruchase_date}</td>
                  <td ${css.td}>${purchaseItem[i].provider_name}</td>
                  <td ${css.td}>${purchaseItem[i].purchase_qty}</td>
                  <td ${css.td}>${purchaseItem[i].available}</td>
                  <td ${css.td}>${cashVal(purchaseItem[i].unit_price)}</td>
                  <td ${css.td}>${cashVal(purchaseItem[i].unit_price * purchaseItem[i].available)}</td>
                </tr> 
            `
      purchaseTotal += parseFloat(purchaseItem[i].unit_price * purchaseItem[i].available);
    }
  }

  table += `<tr><td colspan='6' ${css.td}><div align='right'><h3>TOTAL</h3></div></td><td ${css.td} ><h3>${cashVal(purchaseTotal)}</h3></td></tr></table>`

  return table
}


function generateSoldTable(soldItem) {

  var soldTotal = 0;
  var table = `
              <h2 ${css.tableTitle}>Sold Item</h2>                        
              <table ${css.table} >
                <tr>
                  <th ${css.th}>Sale</th>
                  <th ${css.th}>SALE DATE</th>
                  <th ${css.th}>CUSTOMER</th>
                  <th ${css.th}>SOLD QTY</th>
                  <th ${css.th}>SOLD PRICE</th>
                  <th ${css.th}>ROW TOTAL EARNINGS</th>
                  <th ${css.th}>ROW TOTAL</th>
                </tr> 
        `
  if (soldItem !== null) {
    for (let i = 0; i < soldItem.length; i++) { //console.log('for>>>', soldItem.length)

      let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
                          {"dest":"report",  "act":"jump", 
                           "actJump":"goToSales", "dtId":"sale-dt", "toSearch":"${soldItem[i].saleCode}"  } ] }'`

      table += `
                <tr>
                  <td class='tdClick' ${css.td} ${detailHtml} >${soldItem[i].saleCode}</td>
                  <td ${css.td}>${soldItem[i].saleDate}</td>
                  <td ${css.td}>${soldItem[i].customer}</td>
                  <td ${css.td}>${soldItem[i].qty}</td>
                  <td ${css.td}>${soldItem[i].soldPrice}</td>
                  <td ${css.td}>${soldItem[i].rowTotalEarnings}</td>
                  <td ${css.td}>${soldItem[i].rowTotal}</td>

                </tr> 
            `
      soldTotal += parseFloat(soldItem[i].rowTotal.replace(/[$,]/g, ''));
    }
  }

  table += `<tr><td colspan='6' ${css.td}><div align='right'><h3>TOTAL</h3></div></td><td ${css.td} ><h3>${cashVal(soldTotal)}</h3></td></tr></table>`

  return table
}


function cashVal(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
function rowStyle(i) {

  if (i % 2 === 0) { return '' }
  return css.trGray

}

